import { useListParts } from "@vendata/power-up-sdk";
import { ref } from "vue";
import { useKratosSession } from "@saflib/ory-kratos-sdk";

export function usePartsPageLoader() {
  const sessionQuery = useKratosSession();
  // Load parts list with pagination
  const limit = ref(10000);
  const offset = ref(0);
  const partsQuery = useListParts({ limit, offset });

  return {
    sessionQuery,
    partsQuery,
  };
}
